export const serviceIdMap = new Map();

export const ServiceIds = {
    // Old ids
    free: "cricket-free",
    daily: "vc-fanclash-vodacom-fl-cricket-daily-01",
    weekly: "vc-fanclash-vodacom-fl-cricket-weekly-01",
    monthly: "vc-fanclash-vodacom-fl-cricket-monthly-01",

    // New ids
    dailyInternal: "vc-fanclash-quizinccricket-daily-01",
    weeklyInternal: "vc-fanclash-quizinccricket-weekly-01",
    monthlyInternal: "vc-fanclash-quizinccricket-monthly-01"
}

export const Cloud7ServiceIds = {
    daily: 'CRI851187'
};

const migrationProductIdsByBrand = new Map([
    ['vc-za-en', {free: 247, daily: 248, weekly: 249, monthly: 250, default: 248}],
    ['vc-za-en-demo', {free: 247, daily: 248, weekly: 249, monthly: 250, default: 248}],
    ['vc-encrypt-za-en', {free: 247, daily: 248, weekly: 249, monthly: 250, default: 248}],
    ['mtn-za-en', {default: 224}],
    ['mtn-wp-za-en', {default: 224}],
    ['wp-za-en', {default: 224}],
    ['gp-bd-en', {default: 484}],
]);

serviceIdMap.set(ServiceIds.free, 1);
serviceIdMap.set(ServiceIds.daily, 2);
serviceIdMap.set(ServiceIds.weekly, 3);
serviceIdMap.set(ServiceIds.monthly, 4);

serviceIdMap.set(ServiceIds.dailyInternal, 2);
serviceIdMap.set(ServiceIds.weeklyInternal, 3);
serviceIdMap.set(ServiceIds.monthlyInternal, 4);

serviceIdMap.set(Cloud7ServiceIds.daily, 5);

const legacyServiceMap = new Map([
    [ServiceIds.dailyInternal, ServiceIds.daily],
    [Cloud7ServiceIds.daily, ServiceIds.daily],
    [ServiceIds.weeklyInternal, ServiceIds.weekly],
    [ServiceIds.monthlyInternal, ServiceIds.monthly],
]);

export function getLegacyId(serviceKey) {
    if (legacyServiceMap.has(serviceKey)) {
        return legacyServiceMap.get(serviceKey);
    }
    return serviceKey;
}

export function getMigrationProductIds(brand) {
    return migrationProductIdsByBrand.get(brand);
}

export function getDefaultProductId(brand) {
    const productIds = getMigrationProductIds(brand);
    if (!productIds) return undefined;
    return productIds.default ?? productIds.daily ?? productIds.weekly ?? productIds.monthly ?? productIds.free;
}

export function getProductIdForBrand(brand, serviceId) {
    const productIds = getMigrationProductIds(brand);
    if (!productIds) return undefined;
    const subscriptionKey = getSubscriptionKey(serviceId);
    return productIds[subscriptionKey] ?? getDefaultProductId(brand);
}

function getSubscriptionKey(serviceId) {
    if (serviceId === ServiceIds.free) return 'free';
    if (serviceId === ServiceIds.weekly || serviceId === ServiceIds.weeklyInternal) return 'weekly';
    if (serviceId === ServiceIds.monthly || serviceId === ServiceIds.monthlyInternal) return 'monthly';
    if (serviceId === Cloud7ServiceIds.daily) return 'daily';
    return 'daily';
}
